import SysMenuItem from "./SysMenuItem.vue";
export default {
  name: 'SysMenuItem',
  props: ['item'],
  components: {
    SysMenuItem: SysMenuItem
  }
};